import React from 'react';
import './StatusTag.css';
import { Users, Swords, Clock, CheckCircle, Flag, AlertCircle } from 'lucide-react';
import XhelosTooltip from '@components/ui/general/xhelos-tooltip/XhelosTooltip';
import { useT } from '@/i18n';

/**
 * Un componente reutilizable para mostrar un tag de estado colorido con icono.
 * Hero-badge style adaptado de Alberath wiki.
 * @param {object} props
 * @param {string} props.status - El estado del juego (ej: 'game_lobby', 'game_plan').
 */
const StatusTag = ({ status }) => {
  const t = useT();

  if (!status) return null;

  // cleanStatus para CSS classes y keys de traducción
  const cleanStatus = status.value ? status.value.replace('game_', '') : status.replace('game_', '');

  // Mapeo de iconos por status
  const statusIcons = {
    lobby: Users,
    deploy: Swords,
    plan: Clock,
    resolve: Clock,
    resolved: CheckCircle,
    finish: Flag,
    error: AlertCircle
  };

  const IconComponent = statusIcons[cleanStatus] || Users;

  // Traducir label y tooltip (con fallback al valor original)
  const label = t(`game_status.label.${cleanStatus}`, cleanStatus);
  const tooltip = t(`game_status.tooltip.${cleanStatus}`, `Game status: ${cleanStatus}`);

  return (
    <XhelosTooltip
      content={tooltip}
      placement="top"
      theme="dark"
      trigger="hover"
    >
      <span className={`tag status-tag status-tag-${cleanStatus}`}>
        {label}
        <span className="status-tag-icon">
          <IconComponent size={16} />
        </span>
      </span>
    </XhelosTooltip>
  );
};

export default StatusTag;